module.exports = __webpack_public_path__ + "img/cover-game-05.a2bc9a1b.jpg";